import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError, Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { URLS } from '../constants/URLS';
import { ApiService } from './api.service';
import { AuthenticateserviceService } from './authenticateservice.service';


@Injectable({
  providedIn: 'root'
})
export class WalletinfoService {

  data: any;
  httpOptions = {

    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })

  };
  constructor(
    private http: HttpClient,
    private apiService: ApiService,
    private authService: AuthenticateserviceService
    ) { }


  initiateCashfreePayment(details:any): Observable<any> {
    const requestBody = {
      "vidLibId": details.vidLibId,
      "userId": details.userId,
      "planAmount": details.planAmount,
      "currency": details.currency,
      "contentId": details.contentId,
      "channelId": details.channelId,
      "subscriptionId": details.subscriptionId,
      "durationId": details.durationId,
      "walletId": details.walletId
    }
    return this.apiService.post(`${URLS.subscribeFromCashfree}`,requestBody)
  }

  getWalletInfo(walletId: string) {
    return this.apiService.get(`${URLS.getTqrWallet}/${walletId}`, this.httpOptions)
      .pipe(
        map(responseData => {
          // console.log(JSON.stringify(responseData));
          return responseData.wallet;
        }), catchError(errorRes => {
          return throwError(errorRes);
        }))
  }

  topUpWallet(body:any){
    return this.apiService.post(URLS.topUpWallet, body)
      .pipe(
        map(responseData => {
          return responseData
        }), catchError(errRes => {
          return throwError(errRes)
        })
      )
  }

  subcriptionPayment(body:any){
    return this.apiService.post(URLS.subscribeFromCashfree, body)
      .pipe(
        map(responseData => {
          return responseData;
        }), catchError(errRes => {
          return throwError(errRes)
        })
      )
  }

  walletPayment(body:any){
    return this.apiService.post(URLS.subscribeFromWallet, body)
      .pipe(
        map(responseData => {
          return responseData
        }),catchError(errRes => {
          return throwError(errRes)
        })
      )
  }

  getToqqerPayment(body:any){
    return this.apiService.post(URLS.toqqerPayment, body)
      .pipe(
        map(responseData => {
          return responseData
        }),catchError(errRes => {
          return throwError(errRes)
        })
      )
  }
  
  getUserTransaction(){
    return this.apiService.get(URLS.getTransaction)
      .pipe(
        map(responseData => {
          return responseData
        }),catchError(errRes => {
          return throwError(errRes)
        })
      )
  }

  // getUserSubscriptions(){
  //   return this.http.post<any>(URLS.getUserSubscriptions,{})
  //     .pipe(
  //       map(responseData => {
  //         if(responseData.responseCode === 200 && responseData.responseDto !== ''){
  //           return responseData?.responseDto
  //         }else{
  //           return undefined
  //         }
  //       }),catchError(errRes => {
  //         return throwError(errRes)
  //       })
  //     )
  // }

  getUserSubscriptions() {
    if (this.authService.isGuest()) {
      return of([]);
    }
    return this.apiService.get(`${URLS.useSubscriptions}?_=${Date.now() || Date.now()}`).pipe(
      map(subscriptions => {
        if (!subscriptions) return [];
  
        const now = new Date();
  
        return subscriptions
          .map(sub => ({
            ...sub,
            isActive: new Date(sub.dateOfExpiry) > now
          }))
      }),
      catchError(errRes => throwError(() => errRes))
    );
  }  
  
  // getUserSubscriptions(){
  //   return this.http.get<any>(URLS.useSubscriptions)
  //     .pipe(
  //       map(responseData => {
  //         if(responseData){
  //           return responseData
  //         }else{
  //           return undefined
  //         }
  //       }),catchError(errRes => {
  //         return throwError(errRes)
  //       })
  //     )
  // }
  // getUserSubscriptions(){
  //   return this.http.post<any>(URLS.getUserSubscriptions,{})
  //     .pipe(
  //       map(responseData => {
  //         if(responseData.responseCode === 200 && responseData.responseDto !== ''){
  //           const userSubscriptions = responseData.responseDto.filter((subscription:any) => {
  //             const expiryDate = new Date(subscription.dateOfExpiry);
  //             return expiryDate > new Date();
  //           });
  //           return userSubscriptions
  //         }else{
  //           return undefined
  //         }
  //       }),catchError(errRes => {
  //         return throwError(errRes)
  //       })
  //     )
  // }

  isSubscribed(channelId: string): Observable<{ isSubscribed: boolean; expiringDate: string }> {
    return this.getUserSubscriptions().pipe(
      map(subscriptions => {
        const subscription = subscriptions.find(item => item.channelId == channelId && item.isActive);
        const isSubscribed = !!subscription;
        const expiringDate = subscription?.dateOfExpiry;
        console.log(isSubscribed);
        return { isSubscribed, expiringDate };
      }),
      catchError(errRes => {
        return throwError(errRes);
      })
    );
  }
  
  getOrderStatus(orderId:any){
    return this.http.get<any>(`${URLS.orderStatus}?orderId=${orderId}`)
      .pipe(
        map(responseData => {
          if(responseData){
            return responseData
          }else{
            return undefined
          }
        }),catchError(errRes => {
          return throwError(errRes)
        })
      )
  }

  // isInWatchlist(vidLibId: string): Observable<boolean> {
  //   const userId = localStorage.getItem('userId');
  //   return this.getWatchListOfUser(userId).pipe(
  //     map(watchlist => watchlist.some(item => item.vidLibId == vidLibId)),
  //     catchError(errorRes => {
  //       return throwError(errorRes);
  //     })
  //   );
  // }
}